const scrollCallbacks: Record<string, Function> = {};

export function registerScrollCallback(label: string, callback: Function) {
    scrollCallbacks[label] = callback;
}

export function triggerScrollEvent(container?: HTMLElement) {
    for (let label in scrollCallbacks) {
        if (typeof scrollCallbacks[label] === 'function') {
            scrollCallbacks[label](container);
        }
    }
}

export function removeScrollCallback(label: string) {
    if (typeof scrollCallbacks[label] !== undefined) {
        delete scrollCallbacks[label];
    }
}